module.exports = __webpack_public_path__ + "static/flags/UG-d8e0178ef116a68b25ba4f01973d47eb.gif";